/**
 * Geometry helpers for floor plan validation.
 */

function pointInRotatedRect(px, py, shape) {
  const w = shape.width || 0;
  const h = shape.height || 0;
  const cx = (shape.x || 0) + w / 2;
  const cy = (shape.y || 0) + h / 2;
  const angle = -((shape.rotation || 0) * Math.PI) / 180;
  const dx = px - cx;
  const dy = py - cy;
  const localX = dx * Math.cos(angle) - dy * Math.sin(angle);
  const localY = dx * Math.sin(angle) + dy * Math.cos(angle);
  return Math.abs(localX) <= w / 2 && Math.abs(localY) <= h / 2;
}

export function getSeatCenter(seat) {
  const w = seat.width || 28;
  const h = seat.height || 28;
  return {
    x: (seat.x || 0) + w / 2,
    y: (seat.y || 0) + h / 2,
  };
}

export function isSeatOnSharedArea(seat, shapes = []) {
  const { x, y } = getSeatCenter(seat);
  const sharedAreas = shapes.filter((s) => s.elementType === 'coworking');
  return sharedAreas.some((area) => pointInRotatedRect(x, y, area));
}

export function getInvalidSeatIds(shapes = []) {
  const invalid = new Set();
  for (const shape of shapes) {
    if (shape.elementType !== 'seat') continue;
    if (!isSeatOnSharedArea(shape, shapes)) {
      invalid.add(shape.id);
    }
  }
  return invalid;
}

export function validateSeatPlacements(shapes = []) {
  const invalidIds = getInvalidSeatIds(shapes);
  if (invalidIds.size === 0) return { valid: true, invalidIds };
  return {
    valid: false,
    invalidIds,
    message: `${invalidIds.size} seat(s) are not placed on a shared area. Move them onto a coworking space before saving.`,
  };
}
